import { TYPES} from '../../common/constants';
import * as client from '../../services/client';
import 'react-toastify/dist/ReactToastify.css';
import {
  startPRLoading,
  stopPRLoading,
} from './loader';

let feedbackURL = localStorage.getItem('IsHomerNavigatFromFeedBackTemplate');
let homeOwnerIsRedirectFromEmailTemplateURL = window.location.href;

if (feedbackURL == null || feedbackURL == undefined || feedbackURL == '') {
  localStorage.removeItem('IsHomerNavigatFromFeedBackTemplate');
  let url = new URL(homeOwnerIsRedirectFromEmailTemplateURL);
  let URLparams = new URLSearchParams(url.search);
  if (
    URLparams.has('isShowFeedBackReportPopup') &&
    URLparams.has('ServiceRequestId')
  ) {
    let ServiceRequestId = URLparams.get('ServiceRequestId');
    localStorage.setItem(
      'IsHomerNavigatFromFeedBackTemplate',
      JSON.stringify({
        IsHomerNavigatFromFeedBackTemplate: true,
        ServiceRequestId: ServiceRequestId,
      })
    );
  }
}

export const clearFaqsNotesDocuments = () => ({
  type: TYPES.CLEAR_FAQ_NOTES_DOCUMENTS,
});

export const fetchFaqsNotesDocumentsDone = (payload) => ({
  type: TYPES.FETCH_FAQS_NOTES_DOCUMENTS_DONE,
  payload,
});
const fetchLatestVideosDone = (payload) => ({
  type: TYPES.FETCH_VIDEOS_DONE,
  payload,
});

export const faqsNotesDone = (payload) => ({
  type: TYPES.FETCH_NOTES,
  payload,
});

export const clearNotes = () => ({
  type: TYPES.CLEAR_NOTES,
});

export const fetchFaqsNotesDocuments =
  (assetId, itemdata, loader) => (dispatch) => {
    if (loader === false) {
    } else {
      dispatch(startPRLoading());
    }
    return client
      .fetchFaqsNotesDocumentForAssetByAssetId(
        assetId,
        itemdata ? itemdata : 'itemdata1'
      )
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            dispatch(fetchFaqsNotesDocumentsDone(responsejson));
            dispatch(faqsNotesDone(responsejson));
            dispatch(stopPRLoading());
          });
        } else {
          dispatch(stopPRLoading());
        }
      });
  };

const fetchMaintenanceGuideForAssetByItemIdDone = (payload) => ({
  type: TYPES.FETCH_MAINTENANCE_GUIDE_FOR_ASSET_BY_ITEM_ID_DONE,
  payload,
});

export const fetchLatestFaqsNotesDocuments = (id, type) => (dispatch) => {
  return client.fetchLatestFaqsNotesDocuments(id).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchFaqsNotesDocumentsDone(responsejson));
        if (type === 'MaintenanceGuide') {
          dispatch(fetchMaintenanceGuide(id));
        }
      });
    } else {
      // alert('Something Went Wrong')
    }
  });
};

export const onFetchLatestVideos = (id) => (dispatch) => {
  return client.onFetchLatestVideos(id).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchLatestVideosDone(responsejson));
      });
    } else {
      // alert('Something Went Wrong')
    }
  });
};

export const fetchMaintenanceGuide = (id) => (dispatch) => {
  return client.fetchMaintenanceGuide(id).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchMaintenanceGuideForAssetByItemIdDone(responsejson));
      });
    } else {
      // alert('Something Went Wrong')
    }
  });
};